module.exports = __webpack_public_path__ + "img/member_cards_icon_431006.df2e11f5.png";